import { useReducer } from "react"

const initialState = {
    anyLoading: false,
    data: {
        dateMoreRecent: {},
        fincsEvent: {},
    },
    error: {
        dateMoreRecent: {
            isError: false,
            errorMessage: "",
        },
        fincsEvent: {
            isError: false,
            errorMessage: "",
        },
    },
    loading: {
        moreRecentDate: false,
    },
}

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING": {
            const newLoading = {
                ...state.loading,
                [action.key]: action.payload,
            }
            const anyLoading = Object.values(newLoading).some(Boolean)

            return {
                ...state,
                loading: newLoading,
                anyLoading,
            }
        }
        case "SET_DATA":
            return {
                ...state,
                data: { ...state.data, [action.key]: action.payload },
                error: { ...state.error, [action.key]: {} },
            }
        case "SET_ERROR":
            return { ...state, error: { [action.key]: action.payload } }
        default:
            return state
    }
}

export const useParamaterCalcPrice = (characteristicService, cetip) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const loadDataDateMoreRecent = async () => {
        if (!cetip || cetip === "") {
            dispatch({
                type: "SET_ERROR",
                key: "dateMoreRecent",
                payload: {
                    isError: true,
                    message: "empty cetip value receive",
                },
            })
            return
        }
        dispatch({ type: "SET_LOADING", key: "dateMoreRecent", payload: true })

        try {
            const response =
                await characteristicService.getDataMaisRecente(cetip)

            dispatch({
                type: "SET_DATA",
                key: "dateMoreRecent",
                payload: { response },
            })
            return response?.body?.DataMaisRecente?.[0]
        } catch (e) {
            dispatch({
                type: "SET_ERROR",
                key: "dateMoreRecent",
                payload: { isError: true, message: e },
            })
        } finally {
            dispatch({
                type: "SET_LOADING",
                key: "dateMoreRecent",
                payload: false,
            })
        }
    }

    const loadDataGetFincs = async (referenceDate) => {
        if (!cetip || cetip === "") {
            dispatch({
                type: "SET_ERROR",
                key: "fincsEvent",
                payload: {
                    isError: true,
                    message: "empty cetip value receive",
                },
            })
            return
        }
        let dateReference
        if (referenceDate) {
            dateReference = referenceDate
        } else {
            dateReference = await loadDataDateMoreRecent()
        }

        if (
            !dateReference ||
            dateReference === "" ||
            typeof dateReference !== "string"
        ) {
            dispatch({
                type: "SET_ERROR",
                key: "fincsEvent",
                payload: { isError: true, message: "invalid date reference" },
            })

            dateReference = new Intl.DateTimeFormat("sv-SE").format(new Date())
        }

        dispatch({ type: "SET_LOADING", key: "fincsEvent", payload: true })
        try {
            const response = await characteristicService.getParametersCalc(
                cetip,
                dateReference
            )
            const { body } = response

            if (typeof body === "string") {
                throw new Error("receive string in getParameterCalc")
            }
            dispatch({
                type: "SET_DATA",
                key: "fincsEvent",
                payload: body[0],
            })
        } catch (e) {
            dispatch({
                type: "SET_ERROR",
                key: "fincsEvent",
                payload: { isError: true, message: e },
            })
        } finally {
            dispatch({
                type: "SET_LOADING",
                key: "fincsEvent",
                payload: false,
            })
        }
    }

    return {
        state,
        actions: {
            loadDataGetFincs,
        },
    }
}
